import { gql } from "@apollo/client";

export const MUTATION_CREATE_CASE = gql`
  mutation {
    cases {
      caseCreate {
        case {
          uuid
          reference
          status
          createdOn
          applications {
            reference
            createdOn
            status
          }
          illustrations {
            uuid
            reference
            createdOn
          }
        }
        ok
      }
    }
  }
`;

export const MUTATION_UPLOAD_DOCUMENT = gql`
  mutation UploadDocument(
    $caseUuid: UUID!
    $kind: String!
    $file: Upload!
    $applicationUuid: UUID
  ) {
    cases {
      uploadDocument(
        caseUuid: $caseUuid
        kind: $kind
        file: $file
        applicationUuid: $applicationUuid
      ) {
        uuid
        kind
        name
        createdOn
      }
    }
  }
`;

// Closes the case's open broker consent task.
export const MUTATION_RECORD_BROKER_CONSENT = gql`
  mutation RecordBrokerConsent($caseUuid: UUID!) {
    cases {
      recordBrokerConsent(caseUuid: $caseUuid) {
        name
        createdAt
      }
    }
  }
`;
